import React from 'react'
import Icon from './Icon'

const HasSort = props => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g>
      <path
        d="M8,16.7928932 L10,16.7928932 L12,14.7928932 L14,16.7928932 L16,16.7928932 L12.3535534,13.1464466 L12.3535534,13.1464466 C12.1582912,12.9511845 11.8417088,12.9511845 11.6464466,13.1464466 L8,16.7928932 Z"
        transform="matrix(1 0 0 -1 0 29.793)"
      />
      <path d="M8,11 L10,11 L12,9 L14,11 L16,11 L12.3535534,7.35355339 L12.3535534,7.35355339 C12.1582912,7.15829124 11.8417088,7.15829124 11.6464466,7.35355339 L8,11 Z" />
    </g>
  </Icon>
)

export default HasSort



// WEBPACK FOOTER //
// ./icons/HasSort.js